import { emailBerichten } from "../EmailTemplates";
import { AXIOS_GET, AXIOS_POST, AXIOS_UPDATE } from "../server/api/crud";



const { setMailRoomsLoad, setMailMessage, setMailMessageItemsFilterLoad, setMailMessageItemsLoad } = require("../redux/mailSlice");

export const fetchMailRooms = async (user,dispatch,mailMessage = null,limit,offset,query) => {
    try {
      if (!user?.id) return;
      const authorId = mailMessage?.author_id || user?.id;
      const safeSearch = encodeURIComponent(query || "");

      const response = await AXIOS_GET(`mailbox/mailmessageById/filter/${user?.id}/${authorId}?limit=${limit}&offset=${offset}&search=${safeSearch}`);

      dispatch(setMailRoomsLoad(response.data.data));

      
      if(!mailMessage){
        dispatch(setMailMessage(response.data.data[0]));
      }
     
    } catch (error) {
      // Ignore aborted/cancelled requests (e.g. navigation, reload)
      if (error.code === 'ECONNABORTED' || error.message === 'Request aborted' || error.message === 'canceled') {
        return;
      }
      if (error?.response?.status === 403) {
        console.warn("Mailbox request forbidden for current session/user context.");
      }
      console.error("Error fetching mailrooms", error);
    }
  };

  export const fetchMailRoomsChange = async (user,dispatch,mailMessage = null,limit,offset,query) => {
    try {
      if (!user?.id) return;
      const authorId = mailMessage?.author_id || user?.id;
      const safeSearch = encodeURIComponent(query || "");
      const response = await AXIOS_GET(`mailbox/mailmessageById/filter/${user?.id}/${authorId}?limit=${limit}&offset=${offset}&search=${safeSearch}`);
      dispatch(setMailRoomsLoad(response.data.data));
      const findRoom = (response.data.data).find((item) => item.id == mailMessage.id);
      //dispatch(setMailMessage(findRoom));
    } catch (error) {
      if (error.code === 'ECONNABORTED' || error.message === 'Request aborted' || error.message === 'canceled') {
        return;
      }
      console.error("Error fetching mailrooms", error);
    }
  };


  export const seenMessage = async (user,mailMessage,dispatch) => {
    try {
      const response = await AXIOS_UPDATE(`mailbox/message/seen`,mailMessage.id,{});

     
      if(response.status == 200){

        fetchMailRoomsChange(user,dispatch,mailMessage,8,0,'');
      }

    } catch (error) {
      if (error.code === 'ECONNABORTED' || error.message === 'Request aborted' || error.message === 'canceled') {
        return;
      }
      console.error("Error fetching mailrooms", error);
    }
  };


  export const fetchMailMessages = async (user,dispatch) => {
    try {
      if (!user?.id) return;
      const response = await AXIOS_GET(`mailbox/messageItemsByUser/${user?.id}`);
      dispatch(setMailMessageItemsLoad(response.data.data));
      dispatch(setMailMessageItemsFilterLoad(response.data.data));
    } catch (error) {
      console.error("Error fetching mail messages", error);
    }
  };